module.exports = __webpack_public_path__ + "static/media/clock_summary_24.2ee3cea5.svg";